/*
	This hook provides a simplified interface to opening the SelectAssets modal if the
	calling component isn't already using a modal stack, and doesn't want to replace
	itself with the SelectAssets modal.
*/

import React from "react";
import { useModalStack } from "utils/common";
import SelectAssets from "widgets/modals/assets/SelectAssets";

export default function useSelectAssets(commonProps, configureFilter = null){
	const commonModalProps = {
		title: `Select asset`,
		type: "modal",
		xClose: true,
		allowFullScreen: false,
		bladeProps: {
			verticallyCenter: true,
		},
		onClose: closeModal,
		setAppTitle: false,

		...commonProps,
	};

	// eslint-disable-next-line no-unused-vars
	const [modalStack, { pushModal, clearStack }, ModalStackHead] = useModalStack({ commonModalProps });

	function closeModal(){
		clearStack();
	}

	const openSelectionModal = (type, onSelect) => {
		function Configured(props){
			let selectAssetProps = {
				...props,
				type: type.toLowerCase(),
				onSelect,
				configureFilter,
			};

			return (
				<SelectAssets
					{...selectAssetProps}
				/>
			);
		}
		pushModal(Configured);
	};

	return {
		SelectionModal: ModalStackHead,
		openSelectionModal,
	};
}
